<template>
    <div class="modal-dialog">
        <div class="modal-content " v-if="modalData.type === 'callback'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <p class="title">{{Lang.get('common.fill_form')}}</p>
                <p class="title">{{Lang.get('common.fill_form2')}}</p>

            </div>
            <div class="modal-body">
                <form-call-back></form-call-back>
            </div>
        </div>
        <div class="modal-content " v-if="modalData.type === 'ourTeam'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <p class="title">{{Lang.get('common.tell_you')}}</p>
                <p class="mini_title">{{Lang.get('common.tell_you2')}}</p>
            </div>
            <div class="modal-body">
                <div class="left">
                    <img :src="modalData.src" alt="Photo">
                </div>
                <div class="right">
                    <form-call-back></form-call-back>
                </div>
            </div>
            <div class="bottom">
                <p>{{Lang.get('common.terms')}}</p>
            </div>
        </div>
        <div class="modal-content" v-if="modalData.type === 'login'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <auth-component></auth-component>
            </div>
        </div>
        <div class="modal-content " v-if="modalData.type === 'all_order'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <p class="title">{{Lang.get('common.fill_form')}}</p>
                <p class="mini_title">{{Lang.get('common.fill_form3')}}</p>
            </div>
            <div class="modal-body">
                <form-call-back></form-call-back>
            </div>
        </div>
        <div class="modal-content " v-if="modalData.type === 'hotel_order'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <p class="title">{{Lang.get('common.order_tour')}}</p>
                <p class="mini_title">{{ modalData.country }}</p>
                <p class="mini_title">{{ modalData.resort }}</p>
            </div>
            <div class="modal-body">
                <form-call-back
                        :message="'страна: ' + modalData.country + ', курот: ' + modalData.resort"
                ></form-call-back>
            </div>
        </div>
        <div class="modal-content " v-if="modalData.type === 'findtour'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <p class="title">{{Lang.get('common.send_shares')}}</p>
            </div>
            <div class="modal-body">
                <form-find-tour :countries="modalDataCountries"></form-find-tour>
            </div>
        </div>
    </div>
</template>

<script>
    import FormCallBack from './FormCallBack';
    import AuthComponent from '../auth/AuthComponent';
    import FormFindTour from '../forms/FormFindTour';

    let modalData = window.modal;
    export default {
        name: "FormModal",
        props: {
            modalData: {
                required: true,
                type: Object
            },
            modalDataCountries: {
                required: false
            }
        },
        data() {
            return {
                Lang,
            }
        },
        components: {
            FormCallBack,
            AuthComponent,
            FormFindTour,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FormModal.vue